export default __webpack_public_path__ + "maps-overview-header-image-1200-6e72e961526b61b76bacd7cd3fe8d501.png";